import React, { useEffect } from "react";
import { createPopper } from "@popperjs/core";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "store/Reducer";
// import axios from 'axios'

const UserDropdown = () => {
  const dispatch = useDispatch();
  const{user} = useSelector(state => state.user)
  // console.log(user);
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  useEffect(() => {
      if(!localStorage.getItem('token')){
        window.location.href = "/auth/login";
      }
      axios.get(`http://${process.env.REACT_APP_API_URL}/auth/profile`, {
        headers: {
          Bearer: localStorage.getItem('token')
        }
      }).then((response) => {
        // console.log(response);
        if (response.status === 200) {
          dispatch(addUser(response.data));
          // localStorage.setItem('token', response.data.access_token);
          // window.location.href = "/admin/dashboard";
        }
  
      }
      ).catch((error) => {
        if (error.response.data.status === 401 || error.response.status === 400) {
          window.location.href = "/auth/login";
        }
        // Swal.fire("SweetAlert2 is working!");
  
        console.log(error);
        // console.log(error.response.data.message);
      });
  }, [])

  const logout = () => {
    localStorage.removeItem('token');
    window.location.href = "/auth/login";
  }
  return (
    <>
      <a
        className="block text-blueGray-500"
        href="#pablo"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <div className="flex items-center">
          <span className="text-xl font-bold text-white nav-user">
            {user.username}
          </span>
        </div>
      </a>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
        }
      >
        <a
          href="/user/update-user"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
        >
          Settings
        </a>
        
        <div className="h-0 my-2 border border-solid border-blueGray-100" />
        <a
          href="#pablo"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={logout}
        >
          Logout
        </a>
      </div>
    </>
  );
};

export default UserDropdown;
